module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend"
  }, [_c('div', {
    staticClass: "friendList"
  }, [(_vm.friendList.length > 0) ? _c('ul', [_vm._l((_vm.friendList), function(item, index) {
    return _c('li', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      },
      on: {
        "click": function($event) {
          _vm.friendreport(item.id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      staticClass: "nickName"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v("完成了本测评，ta的代表动物竟然是：")])]), _vm._v(" "), _c('div', {
      staticClass: "animal"
    }, [_c('img', {
      attrs: {
        "src": item.images
      },
      on: {
        "click": function($event) {
          _vm.friendreport(item.id)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.busy) ? _c('p', {
    staticClass: "busy"
  }, [_vm._v("正在加载好友报告")]) : _vm._e()], 2) : _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "smile"
  }), _vm._v(" "), _c('p', [_vm._v("分享本报告，此处有惊喜，记得常回来看看！")])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/funreport-qrcode.png"),
      "alt": "qrcode"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-48fbf8a0!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/funFriendList.vue
// module id = 131
// module chunks = 2